import React from "react";
import { Box } from "@mui/material";
import TeamLeaderboard from "../../TeamLeaderboard";
import BarChart from "../../BarChart";
import BuyerPRList from "../../BuyerPRList";
import styles from "./performanceDashboard.module.scss";

interface PerformanceDashboardProps {
  teamLeaderboard?: any[];
  pctComparisonByBuyers?: any[];
  prByBuyers?: any[];
}

const PerformanceDashboard: React.FC<PerformanceDashboardProps> = ({
  teamLeaderboard = [],
  pctComparisonByBuyers = [],
  prByBuyers = [],
}) => {
  return (
    <>
      <Box className={styles.fullWidthSection}>
        <TeamLeaderboard
          title="Team Leaderboard"
          data={teamLeaderboard}
          periodLabel="This Month"
        />
      </Box>

      <Box className={styles.chartsSection}>
        <BarChart
          title="PCT Comparison by Buyers"
          data={pctComparisonByBuyers}
          xAxisKey="buyer"
          bars={[{ dataKey: "days", color: "#5b6b9e", label: "Days" }]}
          height={320}
        />
        <BuyerPRList
          title="PR by Buyers"
          data={prByBuyers}
          buyerKey="buyer"
          completedKey="completed"
          totalKey="total"
        />
      </Box>
    </>
  );
};

export default PerformanceDashboard;
